import type { ConceptValue } from "../../../services/regulationsService";
import type { ReferenceDimensionSelection } from "./ClassificationCascadePicker";

export type EditAssessmentPlanFormState = {
  objectType: string;
  objectSubType: string;
  /** Display labels for Reference Items while plan-types load. */
  objectTypeName?: string;
  objectSubTypeName?: string;
  /** Reference Dimension from `kind=reference` configurable-concepts. */
  referenceConceptCode?: string;
  referenceConceptDisplayName?: string;
  /** Multi-Dimension Reference selections. */
  referenceDimensions?: ReferenceDimensionSelection[];
  conceptCode: string;
  conceptValues: ConceptValue[];
  assessmentPrompt: string;
  allValues: boolean;
  assessmentName?: string;
  active: boolean;
  /** Concept V3 config fields — mapped to API layer / tagging_approach / etc. */
  taggingApproach: string;
  execution: string;
  /** API `layer` as digit string ("" = unset). */
  layer: string;
  assessmentTemplate: string;
  updateAssessmentRecordConcept: string;
  updateAssessmentRecords: string[];
};

function conceptValuesFingerprint(values: ConceptValue[]): string {
  return [...values]
    .map((value) => value.code)
    .sort((a, b) => a.localeCompare(b))
    .join("\0");
}

/** Compares editable fields against the values loaded when edit opened. */
export function isEditFormDirty(
  current: EditAssessmentPlanFormState,
  initial: EditAssessmentPlanFormState,
): boolean {
  return (
    current.objectSubType !== initial.objectSubType ||
    (current.referenceConceptCode ?? "") !==
      (initial.referenceConceptCode ?? "") ||
    JSON.stringify(current.referenceDimensions ?? []) !==
      JSON.stringify(initial.referenceDimensions ?? []) ||
    current.conceptCode !== initial.conceptCode ||
    current.allValues !== initial.allValues ||
    current.assessmentPrompt !== initial.assessmentPrompt ||
    (current.assessmentName ?? "") !== (initial.assessmentName ?? "") ||
    current.taggingApproach !== initial.taggingApproach ||
    current.execution !== initial.execution ||
    (current.layer ?? "") !== (initial.layer ?? "") ||
    current.assessmentTemplate !== initial.assessmentTemplate ||
    (current.updateAssessmentRecordConcept ?? "") !==
      (initial.updateAssessmentRecordConcept ?? "") ||
    current.updateAssessmentRecords.join("\0") !==
      initial.updateAssessmentRecords.join("\0") ||
    conceptValuesFingerprint(current.conceptValues) !==
      conceptValuesFingerprint(initial.conceptValues)
  );
}
